export const productPdfUrl = "" +
  "mutation productPdfUrl($sku: String!, $attribute: String) {" +
  "productPdfUrl(sku: $sku, attribute: $attribute) {url name}" +
  "}";

